import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // عرض رسالة تحميل أثناء التحقق من المستخدم
  }

  // ✅ إذا كان المستخدم مسجلًا، يتم منعه من الوصول وإعادة توجيهه إلى الصفحة المناسبة
  if (user) {
    const routeMap = {
      "1": "/admin-dashboard",
      "0-1": "/user-dashboard",
      "0-0": "/user-dashboard-two",
    };

    const destination = routeMap[`${user.type}-${user.status}`] || "/";

    return <Navigate to={destination} />;
  }

  return children; // 🟢 إذا لم يكن مسجلًا، يتم السماح له بالدخول
};

export default PublicRoute;
